module.exports = __webpack_public_path__ + "static/media/coverteye-3.3add3cdd.jpg";